export enum ColumnTypeEnum {
  String = 1,
  Number,
  Boolean,
  Date,
  Time,
  Icon,
  Link,
  Guid,
  ImageByte,
  ImageUrl,
  DateGreaterThan,
  DateLessThan,
  DateNullable
}

